import { render, staticRenderFns } from "./Download.vue?vue&type=template&id=ab0df138&scoped=true"
import script from "./Download.vue?vue&type=script&lang=js"
export * from "./Download.vue?vue&type=script&lang=js"
import style0 from "./Download.vue?vue&type=style&index=0&id=ab0df138&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab0df138",
  null
  
)

export default component.exports